import { render } from "./AbsenceCalendar.vue?vue&type=template&id=916b507a&scoped=true"
import script from "./AbsenceCalendar.vue?vue&type=script&lang=js"
export * from "./AbsenceCalendar.vue?vue&type=script&lang=js"

import "./AbsenceCalendar.vue?vue&type=style&index=0&id=916b507a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916b507a"]])

export default __exports__